export const messages = {
  en: {
    serviceBinding: {
      prevStep: 'Previous',
      nextStep: 'Next',
      finish: 'Finish',
      pleaseSelectRequired: 'Please select or fill in required information',
      processSuccess: 'Process successfully',
      processFailed: 'Process failed'
    },
    viewAppInfo: {
      title: 'Application Information',
      selectApp: 'Select App',
      addApp: 'Add App',
      appId: 'App ID',
      appName: 'App Name',
      securityCode: 'Security Code',
      whiteList: 'White List',
      blackList: 'Black List',
      remark: 'Remark'
    },
    addApp: {
      title: 'Add Application',
      appName: 'App Name',
      appNamePlaceholder: 'Required, please enter app name',
      appNameRequired: 'App name is required',
      appNameLength: 'App name must be between 2-50 characters',
      securityCode: 'Security Code',
      securityCodePlaceholder: 'Optional, please enter security code',
      securityCodeLength: 'Security code too long (max 64 characters)',
      whiteList: 'White List',
      whiteListPlaceholder: 'Optional, please enter white list',
      whiteListLength: 'White list content too long (max 200 characters)',
      blackList: 'Black List',
      blackListPlaceholder: 'Optional, please enter black list',
      blackListLength: 'Black list content too long (max 200 characters)',
      remark: 'Remark',
      remarkPlaceholder: 'Optional, please enter remark',
      remarkLength: 'Remark content too long (max 200 characters)',
      cancel: 'Cancel',
      save: 'Save',
      saveSuccess: 'Save successfully',
      saveFailed: 'Save failed'
    },
    chooseApp: {
      title: 'Select Application',
      searchPlaceholder: 'Enter app name',
      appId: 'App ID',
      appName: 'App Name',
      operation: 'Operation',
      select: 'Select'
    },
    viewServiceInfo: {
      title: 'Service Information',
      selectService: 'Select Service',
      addService: 'Add Service',
      serviceId: 'Service ID',
      serviceName: 'Service Name',
      serviceCode: 'Service Code',
      messageQueue: 'Message Queue',
      isInstance: 'Is Instance',
      url: 'URL',
      method: 'Method',
      timeout: 'Timeout',
      retryCount: 'Retry Count'
    },
    
    chooseService: {
      title: 'Select Service',
      searchPlaceholder: 'Enter service name',
      serviceName: 'Service Name',
      serviceCode: 'Service Code',
      method: 'Method',
      operation: 'Operation',
      select: 'Select'
    },
    addRouteView: {
      title: 'Service Binding',
      orderType: 'Order Type',
      orderTypePlaceholder: 'Required, please select order type',
      orderTypeRequired: 'Order type is required',
      orderTypeLength: 'Order type error',
      query: 'Query',
      businessAccept: 'Business Accept',
      invokeLimitTimes: 'Invoke Limit Times',
      invokeLimitTimesPlaceholder: 'Required, please enter invoke limit times',
      invokeLimitTimesRequired: 'Invoke limit times is required',
      invokeLimitTimesNumber: 'Invoke limit times must be number',
      invokeModel: 'Invoke Model',
      invokeModelPlaceholder: 'Required, please select invoke model',
      invokeModelRequired: 'Invoke model is required',
      invokeModelLength: 'Invoke model too long (max 50 characters)',
      syncMode: 'Sync Mode',
      asyncMode: 'Async Mode'
    }
  },
  zh: {
    serviceBinding: {
      prevStep: '上一步',
      nextStep: '下一步',
      finish: '完成',
      pleaseSelectRequired: '请选择或填写必选信息',
      processSuccess: '处理成功',
      processFailed: '处理失败'
    },
    viewAppInfo: {
      title: '应用信息',
      selectApp: '选择应用',
      addApp: '添加应用',
      appId: '应用ID',
      appName: '应用名称',
      securityCode: '秘钥',
      whiteList: '白名单',
      blackList: '黑名单',
      remark: '备注'
    },
    addApp: {
      title: '添加应用',
      appName: '应用名称',
      appNamePlaceholder: '必填，请填写应用名称',
      appNameRequired: '应用名称不能为空',
      appNameLength: '应用名称必须在2至50字符之间',
      securityCode: '秘钥',
      securityCodePlaceholder: '选填，请填写秘钥',
      securityCodeLength: '秘钥太长超过64位',
      whiteList: '白名单',
      whiteListPlaceholder: '选填，请填写白名单',
      whiteListLength: '白名单内容不能超过200',
      blackList: '黑名单',
      blackListPlaceholder: '选填，请填写黑名单',
      blackListLength: '黑名单内容不能超过200',
      remark: '备注',
      remarkPlaceholder: '选填，请填写备注',
      remarkLength: '备注内容不能超过200',
      cancel: '取消',
      save: '保存',
      saveSuccess: '添加成功',
      saveFailed: '添加失败'
    },
    chooseApp: {
      title: '选择应用',
      searchPlaceholder: '输入应用名称',
      appId: '应用ID',
      appName: '应用名称',
      operation: '操作',
      select: '选择'
    },
    viewServiceInfo: {
      title: '服务信息',
      selectService: '选择服务',
      addService: '添加服务',
      serviceId: '服务ID',
      serviceName: '服务名称',
      serviceCode: '服务编码',
      messageQueue: '消息队列',
      isInstance: '是否实例',
      url: '调用地址',
      method: '调用方式',
      timeout: '超时时间',
      retryCount: '重试次数'
    },
    chooseService: {
      title: '选择服务',
      searchPlaceholder: '输入服务名称',
      serviceName: '服务名称',
      serviceCode: '服务编码',
      method: '调用方式',
      operation: '操作',
      select: '选择'
    },
    addRouteView: {
      title: '服务绑定',
      orderType: '订单类型',
      orderTypePlaceholder: '必填，请选择订单类型',
      orderTypeRequired: '订单类型不能为空',
      orderTypeLength: '订单类型错误',
      query: '查询',
      businessAccept: '业务受理',
      invokeLimitTimes: '调用次数',
      invokeLimitTimesPlaceholder: '必填，请填写调用次数',
      invokeLimitTimesRequired: '调用次数不能为空',
      invokeLimitTimesNumber: '调用次数错误',
      invokeModel: '调用方式',
      invokeModelPlaceholder: '必填，请选择调用方式',
      invokeModelRequired: '调用方式不能为空',
      invokeModelLength: '消息队列不能超过50',
      syncMode: '同步方式',
      asyncMode: '异步方式'
    }
  }
}